import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { spring, useUITheme, ThemeToggle, pageTheme } from "@/components/ios";

export default function PaymentCancel() {
  const { dark, toggle } = useUITheme();
  const t = pageTheme(dark);

  return (
    <main className={`min-h-screen flex items-center justify-center px-5 py-10 font-sans ${t.page}`} data-testid="payment-cancel-page" data-theme={dark ? "dark" : "light"}>
      <div className="fixed top-5 right-5 z-40">
        <ThemeToggle dark={dark} onToggle={toggle} testid="cancel-theme-toggle" />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={spring}
        className={`rounded-[32px] p-8 md:p-12 max-w-lg w-full text-center ${t.card}`}
      >
        <div className="flex justify-center mb-8"><Logo /></div>
        <XCircle className={`w-12 h-12 ${t.tertiary} mx-auto mb-5`} strokeWidth={1.5} />
        <h1 className={`font-bold tracking-tight text-3xl mb-3 ${t.primary}`}>Checkout cancelled.</h1>
        <p className={`text-[15px] ${t.secondary} leading-relaxed mb-8`}>
          No charge was made. The engine will be here when you're ready.
        </p>
        <Link to="/#pricing" data-testid="back-to-pricing-link"
          className={`inline-flex items-center justify-center gap-2 min-h-[48px] px-6 rounded-full ${t.primaryBtn} text-[15px] font-semibold active:scale-[0.98] transition-transform duration-150`}>
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Back to pricing
        </Link>
      </motion.div>
    </main>
  );
}
